import { useState } from 'react';
import { useAuth } from '../firebase/AuthContext';
import { trackSignOut, trackButtonClick } from '../services/analytics';
import AuthButtons from './AuthButtons';

const GoogleSignInButton = ({ variant = 'header', signupOnly = false, onError = null, testResults = null }) => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSignOut = async () => {
    setLoading(true);
    trackButtonClick('sign_out', variant);
    await logout();
    trackSignOut();
    setLoading(false);
  };

  if (user) {
    if (variant === 'header') {
      return (
        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-100 border border-gray-200">
          {user.photoURL && (
            <img 
              src={user.photoURL} 
              alt={user.displayName}
              className="w-7 h-7 rounded-full"
            />
          )}
          <span className="text-sm font-medium text-gray-700">
            {user.displayName || user.email}
          </span>
        </div>
      );
    }
    
    if (variant === 'signout') {
      return (
        <button
          onClick={handleSignOut}
          disabled={loading}
          className={`px-5 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors ${
            loading ? 'opacity-60 cursor-not-allowed' : ''
          }`}
        >
          {loading ? 'Signing out...' : 'Sign Out'}
        </button>
      );
    }
  }

  // Use AuthButtons component for sign in / sign up
  return <AuthButtons variant={variant} testResults={testResults} />;
};

export default GoogleSignInButton;